import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/campaign/"
    path="business/campaign/:feature"
    element={<AsyncPage />}
  />,
];
